import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Tengo que dejar de comer carbohidratos?',
  answer: 'No. Aprenderás a comer los carbohidratos correctos en el momento correcto para que trabajen para tu energía, no para tu cintura.'
}, {
  question: '¿Funciona si ya estoy en terapia de reemplazo hormonal?',
  answer: 'Absolutamente. Este sistema optimiza la forma en que tu cuerpo procesa cualquier soporte hormonal médico que estés recibiendo.'
}, {
  question: '¿Cuánto tiempo necesito al día?',
  answer: 'El sistema está diseñado para mujeres ocupadas. Solo necesitas 15-20 minutos al día para preparar tus comidas siguiendo el protocolo de sincronización hormonal.'
}, {
  question: '¿Necesito comprar suplementos caros?',
  answer: 'No. Este programa se basa en alimentos reales y accesibles que puedes encontrar en cualquier supermercado. No hay suplementos obligatorios.'
}, {
  question: '¿Funciona si tengo más de 55 años?',
  answer: 'Sí. El sistema funciona para cualquier mujer en la etapa de la menopausia, sin importar si estás en la perimenopausia, menopausia o postmenopausia.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-cream py-20 md:py-28" data-id="element-14">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-16">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal mb-16 text-center" data-id="element-17">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-18">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-warm-white rounded-lg shadow-md overflow-hidden" data-id="element-19">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 md:px-8 py-6 flex items-center justify-between text-left hover:bg-cream/50 transition-colors" data-id="element-20">
                  <span className="font-serif text-lg md:text-xl text-charcoal pr-4" data-id="element-21">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-22">
                    <ChevronDownIcon className="w-6 h-6 text-gold flex-shrink-0" data-id="element-23" />
                  </motion.div>
                </button>

                <motion.div initial={false} animate={{
              height: openIndex === index ? 'auto' : 0,
              opacity: openIndex === index ? 1 : 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-24">
                  <div className="px-6 md:px-8 pb-6 text-charcoal/80 text-base md:text-lg leading-relaxed" data-id="element-25">
                    {faq.answer}
                  </div>
                </motion.div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}